import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/localEstoque' };
/////////////////////////////////////////////////////////////////////////////////

export function createLocalEstoqueCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateLocalEstoqueCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listLocalEstoqueCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findLocalEstoqueCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllLocalEstoqueCadastro() {
  return httpService.get({ ...args, path: '/localEstoque/all' });
}

export function deleteLocalEstoqueCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

